import {Divider} from "@mui/material";
import {memo} from "react";

const StyledDivider = () => {
  return (
    <Divider sx={{ background:"#949494", borderBottomWidth: 5}} />
  );
};

export default memo(StyledDivider);